// extracted by mini-css-extract-plugin
module.exports = {"body":"Modal_body__2CGUz","cover":"Modal_cover__2zXyX","content":"Modal_content__2_LKU","closeBtn":"Modal_closeBtn__1JGcx"};